import { useTranslation } from 'next-i18next'
import { FC } from 'react'
import { IJobBase } from '../../../types'
import { getFormattedAmount } from '../../../utils'
import styles from './index.module.scss'

type Props = {
  job: IJobBase
}

export const JobAttributes: FC<Props> = ({ job }) => {
  const { t } = useTranslation('jobs')

  return (
    <>
      {job?.locations?.length > 0 && (
        <div className={styles.location}>
          {job?.locations?.map((location, i) => {
            return (
              <span key={location.slug}>{job?.locations.length - 1 === i ? location.name : `${location.name}・`}</span>
            )
          })}
          <span>（{t(job?.workingForm)}）</span>
        </div>
      )}
      {!(job?.minMonthlySalary === '0' && job?.maxMonthlySalary === '0') && (
        <div className={styles.salary}>
          <span>
            {getFormattedAmount(Number(job?.minMonthlySalary), job?.currencyUnit)}
            {' - '}
            {getFormattedAmount(Number(job?.maxMonthlySalary), job?.currencyUnit)}
          </span>
        </div>
      )}
      {job?.skills?.length > 0 && (
        <div className={styles.skill}>
          {job?.skills?.map((skill, i) => {
            return <span key={skill.slug}>{job?.skills.length - 1 === i ? skill.name : `${skill.name}・`}</span>
          })}
        </div>
      )}
      {job?.jobTags?.length > 0 && (
        <div className={styles.jobTag}>
          {job?.jobTags?.map((jobTag, i) => {
            return <span key={jobTag.slug}>{job?.jobTags.length - 1 === i ? jobTag.name : `${jobTag.name}・`}</span>
          })}
        </div>
      )}
    </>
  )
}
